// ── 드롭 아이템 단가 데이터 ──────────────────────────
// 단가 변경 시 이 파일만 수정하세요.

export const DROP_ITEMS = [
  { key: "milk",   name: "순록의 우유",    price: 2750  },
  { key: "tdew",   name: "황혼의 이슬",    price: 5100  },
  { key: "ddew",   name: "새벽의 이슬",    price: 4050  },
  { key: "cheese", name: "살살녹는 치즈",  price: 2250  },
];
